"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ExpandVertical = ExpandVertical;
var _react = _interopRequireDefault(require("react"));
var _shared = require("../shared");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
//
// Main component
// -------------------------------------------------------------------------------------------------

function ExpandVertical({
  color,
  size = 1
}) {
  return /*#__PURE__*/_react.default.createElement(_shared.SVG, {
    heightAndWidth: size,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/_react.default.createElement(_shared.Path, {
    d: "M12 19.585l-5.293-5.293-1.414 1.414L12 22.413l6.707-6.707-1.414-1.414zM12 1.585L5.293 8.292l1.414 1.414L12 4.413l5.293 5.293 1.414-1.414z",
    fillColor: color
  }));
}